// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__nCOjg","dropdown":"styles_dropdown__AOfJU","arrow":"styles_arrow__yS8Or","title":"styles_title__li3u9","popup":"styles_popup__LP4sW"};